export const SUPABASE_URL = 'https://onoqptkiydcdwfgqrdbw.supabase.co';
export const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9ub3FwdGtpeWRjZHdmZ3FyZGJ3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM4NDYwMzMsImV4cCI6MjA4OTQyMjAzM30.lJl0xQWIhxNBfyghglt0oNrpvNo-5NaLxAJ-ZyYW2Ok';
